import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { primaryColor, secondaryColor } from '../../../utils/comon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faSignInAlt } from '@fortawesome/free-solid-svg-icons';

const NotFound = () => {
    const navigate = useNavigate();
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const pColor = primaryColor();
    const sColor = secondaryColor();

    return (
        <div className="h-screen flex items-center justify-center px-4 relative overflow-hidden" style={{ backgroundColor: sColor }}>
            {/* Animated Background Orbs */}
            <div className="absolute top-[-10%] left-[-10%] w-[400px] h-[400px] rounded-full bg-white blur-[100px] opacity-60 animate-pulse" />
            <div className="absolute bottom-[-10%] right-[-10%] w-[300px] h-[300px] rounded-full bg-white blur-[80px] opacity-40 animate-pulse" style={{ animationDelay: '2s' }} />

            <div className="max-w-2xl w-full text-center z-10 flex flex-col items-center">
                <div className="relative mb-6">
                    {/* Big 404 Text - Reduced size */}
                    <h1
                        className="text-[120px] sm:text-[150px] font-black leading-none select-none tracking-tighter"
                        style={{
                            color: pColor,
                            textShadow: '8px 8px 0px rgba(227, 31, 38, 0.1)',
                            WebkitTextStroke: '1px rgba(227, 31, 38, 0.2)'
                        }}
                    >
                        404
                    </h1>

                    {/* Overlay Label */}
                    <div
                        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white/90 backdrop-blur-md border border-[#FEECEE] px-5 py-1.5 rounded-xl shadow-xl rotate-[-5deg]"
                    >
                        <span className="text-[#E31F26] font-bold text-lg sm:text-xl whitespace-nowrap uppercase tracking-widest">Page Not Found</span>
                    </div>
                </div>

                <div className="space-y-4 max-w-lg">
                    <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
                        Oops! You've found a glitch.
                    </h2>
                    <p className="text-base text-gray-600 leading-relaxed px-4">
                        The page you're looking for doesn't exist or you don't have the necessary permissions to view it.
                    </p>
                </div>

                <div className="mt-8 flex flex-col sm:flex-row gap-4 w-full justify-center px-4">
                    <button
                        onClick={() => navigate(isAuthenticated ? '/overview' : '/login')}
                        className="group relative flex items-center justify-center px-6 py-3 text-white text-base font-semibold rounded-xl transition-all duration-300 hover:bg-[#c41b21] hover:scale-105 active:scale-95 shadow-lg" style={{ backgroundColor: pColor }}
                    >
                        <FontAwesomeIcon icon={isAuthenticated ? faHome : faSignInAlt} className="mr-2.5 transition-transform group-hover:rotate-12" />
                        {isAuthenticated ? 'Back to Dashboard' : 'Go to Login'}
                    </button>

                </div>

                {/* Decorative Elements */}
                <div className="mt-10 flex items-center space-x-2 text-gray-400">
                    <div className="w-6 h-[1px] bg-gray-300" />
                    <span className="text-xs font-medium uppercase tracking-widest">Lost in Space</span>
                    <div className="w-6 h-[1px] bg-gray-300" />
                </div>
            </div>

            {/* Footer Logo - Positioned more compactly */}
            <div className="absolute bottom-6 left-0 w-full flex justify-center items-center px-8">
                <div className="flex flex-col items-center space-y-2 cursor-pointer group" onClick={() => window.open("https://zentechinfo.com/", "_blank")}>
                    <img
                        src="/zentech.svg"
                        alt="Zentech"
                        className="h-6 object-contain opacity-70 grayscale group-hover:opacity-100 group-hover:grayscale-0 transition-all duration-300"
                    />
                    <p className="text-gray-400 text-[10px]">© 2026 Hello! Web. All rights reserved.</p>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
